import {
	GamingActivityReviewReportDto,
	ReportResultDto,
} from "@api-types/reports/ReportResultDto";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class ReportApiService {
	static baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/reports`;
	}
	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type"] = "application/json";
		appHeaders["Accept"] = "application/json";

		return appHeaders;
	};

	static getGamingHistoryReport(
		startDate: string,
		endDate: string
	): Promise<ReportResultDto<GamingActivityReviewReportDto>> {
		const context = getApiRequestContext();

		const requestHeaders = this.getRequestHeaders(context);

		var filter = {
			filter: {
				accessChannels: {
					shops: [
						{
							agencyId: context?.agencyId,
						},
					],
				},
				parameters: [
					{
						column: "DateFrom",
						value: startDate,
					},
					{
						column: "DateTo",
						value: endDate,
					},
					{
						column: "CasinoProviderGameTypeAbrv",
						value: "casino-game",
					},
				],
			},
		};
		return httpClient.post(
			ReportApiService.baseUrl() + "/GamingActivityReview",
			JSON.stringify(filter),
			requestHeaders
		);
	}
}

export default ReportApiService;
